// utils/logout.js
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  // Clear cookies (optional)
  document.cookie = "post_login_verify_payload=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  document.cookie = "post_login_quick_summary_path=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

  // Redirect to login
  window.location.href = '/'; 
};
